import { isEmpty } from 'lodash';

import {
  PDF,
  XLS,
  TEXT,
  TEXTAREA,
  START,
  FIRST,
  SECOND,
  COMPLETED,
  ACTIVATED,
  DISABLED,
  AVAILABLE,
  NOT_AVAILABLE,
  IN_REVIEW,
  PAYTM_CODE,
  PAYPAL_CODE,
} from '../constants';

export const getPaymentMethodIconName = code => {
  switch (code) {
    case 6061:
    case 4506: {
      return 'zestmoney';
    }
    case 3003:
    case 3071:
    case 6004:
    case 11003: {
      return 'axis';
    }
    case 3043:
    case 6005: {
      return 'standard chartered';
    }
    case 5001: {
      return 'paypal';
    }
    case 4503: {
      return 'lazypay';
    }
    case 3073:
    case 3022:
    case 6007:
    case 6055: {
      return 'icici';
    }
    case 3032:
    case 6008:
    case 6053:
    case 11004:
    case 4505: {
      return 'kotak';
    }
    case 6009:
    case 3066:
    case 3044: {
      return 'sbi';
    }
    case 3058:
    case 3077:
    case 6006: {
      return 'yes';
    }
    case 3021:
    case 3084:
    case 6010:
    case 6050:
    case 11002: {
      return 'hdfc';
    }
    case 3020:
    case 6018:
    case 6051: {
      return 'federal';
    }
    case 6054: {
      return 'HOME_CREDIT';
    }
    case 3028:
    case 6012: {
      return 'indusind';
    }
    case 6011: {
      return 'citi';
    }
    case 4001:
    case 4508: {
      return 'freecharge';
    }
    case 4002: {
      return 'mobikwik';
    }
    case 4003:
    case 4502: {
      return 'ola';
    }
    case 4004: {
      return 'jiomoney';
    }
    case 4006: {
      return 'airtelmoney';
    }
    case 4007: {
      return 'paytm';
    }
    case 4008: {
      return 'amazonpay';
    }
    case 4009: {
      return 'phonepe';
    }
    case 4504: {
      return 'hdfcpaylater';
    }
    case 1014:
    case 2005:
    case 2009:
    case 1004:
    case 1009:
    case 2001:
    case 1012:
    case 1001:
    case 1013:
    case 10001: {
      return 'visa';
    }
    case 1002:
    case 1005:
    case 1010:
    case 1015:
    case 1016:
    case 1017:
    case 2002:
    case 2006:
    case 2010:
    case 10002: {
      return 'mastercard';
    }
    case 1007:
    case 2004:
    case 10004: {
      return 'rupay';
    }
    case 2003:
    case 2007:
    case 10003: {
      return 'maestro';
    }
    case 1003:
    case 1006:
    case 1011:
    case 6016: {
      return 'amex';
    }
    case 1008: {
      return 'diners';
    }
    case 6015:
    case 6056: {
      return 'bob';
    }
    case 6062: {
      return 'kreditbee';
    }
    case 4507: {
      return 'simpl';
    }
    case 3024:
    case 6052: {
      return 'idfc';
    }
    case 3037: {
      return 'pnsb';
    }
    case 3038:
    case 3065: {
      return 'pnb';
    }
    case 3114:
    case 6014:
    case 3039: {
      return 'rbl';
    }
    case 3040: {
      return 'saraswat';
    }
    case 3055:
    case 3067: {
      return 'union';
    }
    case 3019:
    case 3072: {
      return 'dhanlakshmi';
    }
    case 3009: {
      return 'canara';
    }
    case 3007: {
      return 'bom';
    }
    case 3010: {
      return 'csb';
    }
    case 3012:
    case 3083: {
      return 'cub';
    }
    case 3016: {
      return 'deutsche';
    }
    case 3018:
    case 3062: {
      return 'dcb';
    }
    case 3023: {
      return 'idbi';
    }
    case 3026: {
      return 'indian';
    }
    case 3029: {
      return 'jkb';
    }
    case 3030: {
      return 'karnataka';
    }
    case 3031: {
      return 'kvbl';
    }
    case 3064: {
      return 'lvbc';
    }
    case 3042: {
      return 'sib';
    }
    case 3052: {
      return 'tammerc';
    }
    case 3122:
    case 3054: {
      return 'uco';
    }
    case 3086: {
      return 'shivalik';
    }
    case 3089: {
      return 'utksr';
    }
    case 3087:
    case 6017: {
      return 'ausmall';
    }
    case 3076: {
      return 'equitas';
    }
    case 3092:
    case 6013: {
      return 'hsbc';
    }
    case 3061:
    case 3006: {
      return 'boi';
    }
    case 3017: {
      return 'dbs';
    }
    case 3081:
    case 3027: {
      return 'iob';
    }
    case 3091: {
      return 'gsc';
    }
    case 3090: {
      return 'sur';
    }
    case 3088:
    case 3079: {
      return 'bandhan';
    }
    case 3051: {
      return 'tnsc';
    }
    case 3041:
    case 3075: {
      return 'svcb';
    }
    case 3011: {
      return 'cbi';
    }
    // // International Cards
    default:
      return 'NETBANKING';
  }
};

export const getPaypalError = data => {
  const result = [];
  if (data.active) {
    return [];
  }
  if (!data.emailIdConfirmed) {
    result.push(
      'Please verify your email address using the confirmation link received over email associated with your PayPal account.',
    );
  }
  if (!data.paymentEnabled) {
    result.push(
      'Please upload a photo ID proof on PayPal dashboard to enable payment collection on your PayPal account.',
    );
  }
  return result;
};

export const filterAttributes = ({
  data,
  filters,
  paytmTestConfig,
  paypalAccount,
}) => {
  const result = {};
  const { status, search } = filters;
  let isEntireModeDisabled = Object.keys(data).length > 0;

  let isAnyModeActive = false;

  Object.keys(data).forEach(key => {
    result[key] = [];
    data[key].forEach(obj => {
      // check if we have to disable a payment group
      if (isEntireModeDisabled)
        isEntireModeDisabled = obj.status?.trim().toUpperCase() === DISABLED;
      // logic for filtering attributes
      const filteredAttributes = obj.attributes.filter(attribute => {
        // for search filter
        let searchFilter = false;
        if (search && search.value) {
          searchFilter = attribute.display
            ?.trim()
            .toLowerCase()
            .includes(search.value?.trim().toLowerCase());
        } else {
          searchFilter = true;
        }

        if (attribute.status === ACTIVATED && !isAnyModeActive)
          isAnyModeActive = true;

        // for status filter
        let statusFilter = false;
        if (status && status.length > 0) {
          statusFilter =
            status.includes(attribute.status) || status.includes('ALL');
          // check for PAYTM - Pending status
          if (
            !statusFilter &&
            attribute.parentCode === PAYTM_CODE &&
            status.includes(IN_REVIEW)
          )
            statusFilter =
              [AVAILABLE, IN_REVIEW].includes(attribute.status) &&
              !isEmpty(paytmTestConfig);

          // check for PAYPAL - Enabled status
          if (
            !statusFilter &&
            attribute.parentCode === PAYPAL_CODE &&
            status.includes(ACTIVATED)
          )
            statusFilter =
              ![NOT_AVAILABLE, DISABLED].includes(attribute.status) &&
              paypalAccount.active;
        } else {
          statusFilter = true;
        }

        return searchFilter && statusFilter;
      });

      result[key].push({
        display: obj.display,
        uniqueIdentifier: obj.uniqueIdentifier,
        status: obj.status,
        attributes: filteredAttributes,
      });
    });
  });

  return {
    filteredAttributes: result,
    disablePaymentGroup: isEntireModeDisabled,
    isAnyModeActive,
  };
};

export const formatAttributes = (data = []) => {
  const result = {};
  data.forEach(obj => {
    if (result[obj.display]) result[obj.display].push(obj);
    else result[obj.display] = [obj];
  });
  return result;
};

export const addButtonTypeAttribute = () => {
  let shouldResetValue = false;
  const documentGrid = document.getElementsByClassName('document-grid');
  // eslint-disable-next-line no-restricted-syntax
  for (const elem of documentGrid) {
    const uploadFileElement = elem.getElementsByClassName('ui form');
    if (uploadFileElement && uploadFileElement.length) {
      const [btn] = uploadFileElement[0].getElementsByTagName('button');
      if (btn) {
        btn.type = 'button';
        shouldResetValue = true;
      }
    }
  }
  return shouldResetValue;
};

export const isFileSelected = obj => !!(obj.docKey && obj.value);

export const isFile = type => [PDF, XLS].includes(type.trim().toUpperCase());

export const isText = type =>
  [TEXT, TEXTAREA].includes(type.trim().toUpperCase());

export const getDescriptionByStage = stage => {
  switch (stage) {
    case START:
    case FIRST:
    case SECOND:
      return 'Click on the toggle again and complete the test transactions. A report will be generated in order to validate the linking of your Cashfree account with your Paytm wallet.';
    case COMPLETED:
      return 'We have generated a report on successful transactions, share it with your paytm AM and get the Prod Credentials.';
    default:
      return 'Connect your Paytm business account with Cashfree to enable this payment method.';
  }
};

export const isActivatedInstantly = (paymentMethodCode, response) => {
  const result = response.find(
    obj => obj.paymentModeCode === paymentMethodCode,
  );
  if (result) {
    return result.status === ACTIVATED;
  }
  return false;
};

export const getDisabledPaperClassName = (
  disableInternationalCards,
  disablePaymentSubGroup,
) => {
  let className = '';
  if (disablePaymentSubGroup) {
    className = 'disabled-payment-group';
  } else if (disableInternationalCards) {
    className = 'disabled-paper';
  }
  return className;
};

export const prepareUpdatePaypalConfigPayload = data => ({
  id: data.id,
  merchantId: data.merchantId,
  isActive: data.active,
  isEmailIdConfirmed: data.emailIdConfirmed,
  isPaymentEnabled: data.paymentEnabled,
  isRefundEnabled: data.refundEnabled,
  isRealtimePaymentEnabled: data.realtimePaymentEnabled,
  isCaptureEnabled: data.captureEnabled,
  isForexMarkupEnabled: data.forexMarkupEnabled,
  conFee: data.conFee,
  mid: data.mid,
});

export const findEffectiveSavings = data => {
  const { withMarkup, withoutMarkup } = data;
  return (((withoutMarkup - withMarkup) / withoutMarkup) * 100).toFixed(2);
};
